/* Gallery pagination dots — syncs with Symmetry's carousel-slider */
(function () {
  function initDots(dotsEl) {
    if (dotsEl.dataset.dotsReady === 'true') return;

    var mainImage = dotsEl.closest('.main-image');
    var carousel = mainImage ? mainImage.querySelector('carousel-slider') : null;
    if (!carousel) return;

    var slider = carousel.querySelector('.slider');
    var dots = Array.prototype.slice.call(dotsEl.querySelectorAll('.gallery-dots__dot'));
    if (!slider || !dots.length) return;

    dotsEl.dataset.dotsReady = 'true';

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    // Slide changed (swipe, arrows, or a variant switching the featured image)
    carousel.addEventListener('on:carousel-slider:select', function (evt) {
      setActive(evt.detail.index);
    });

    // Fallback for browsers/paths that don't fire the custom event
    slider.addEventListener('scroll', function () {
      var slides = slider.querySelectorAll('.slider__item');
      if (!slides.length) return;
      var span = slides[0].offsetWidth || 1;
      setActive(Math.round(Math.abs(slider.scrollLeft) / span));
    }, { passive: true });

    // Tapping a dot jumps to that image
    dotsEl.addEventListener('click', function (evt) {
      var dot = evt.target.closest('.gallery-dots__dot');
      if (!dot) return;
      var index = parseInt(dot.dataset.index, 10);
      var slides = slider.querySelectorAll('.slider__item');
      if (!slides[index]) return;
      slider.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      setActive(index);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-gallery-dots]').forEach(initDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after section reloads in the theme editor
  document.addEventListener('shopify:section:load', initAll);
})();
